<template lang="pug">
  v-autocomplete(
    :value="value"
    :items="items"
    :loading="isFetching"
    :error-messages="errorMessages"
    :label="label"
    :autofocus="autofocus"
    no-data-text="Cargando Bancos..."
    name="banco"
    hide-no-data
    @input="onInput"
  )
</template>

<script>
  import { mapGetters, mapActions, mapState } from 'vuex';

  export default {
    name: 'bank-select',

    props: {
      value: { type: [Object, String, Number] },
      errorMessages: { type: [Array, String], default: () => [] },
      none: { type: Boolean, default: false },
      autofocus: { type: Boolean, default: false },
      label: { type: String },
    },

    computed: {
      ...mapGetters('inputs/banks', ['items']),

      ...mapState('inputs/banks', {
        isFetching: state => state.isFetching,
        isFetched: state => state.isFetched,
      }),
    },

    methods: {
      ...mapActions('inputs/banks', {
        fetch: 'fetch',
      }),

      onInput(value) {
        this.$emit('input', value);
      },
    },

    mounted() {
      if (!this.isFetched && !this.isFetching) this.fetch();
    },
  };
</script>